import { useQuery } from "@tanstack/react-query";
import { gqlRequest } from "@/api/graphql/request";
import { KEYWORD_STATS } from "@/api/graphql/operations/keywords";
import type { KeywordStat } from "@/api/types";

export function useTopKeywords(count = 7) {
  return useQuery({
    queryKey: ["dashboard", "top-keywords", count],
    queryFn: () =>
      gqlRequest<{ keywordStats: KeywordStat[] }>(KEYWORD_STATS, {
        count,
      }).then((d) => d.keywordStats),
    staleTime: 60_000,
  });
}
